<template>
  <div class="container">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Package UUID</td>
          <td class="col-6 head">Package Type</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.uuid == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.uuid }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.type == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.type }}
          </td>
        </tr>
        <tr>
          <td class="head">Ingestion Date</td>
          <td class="head">Package Version</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.date_of_ingestion == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{
              $filters.formatUnixDateTime(
                typesenseStore.currentContent?.date_of_ingestion
              )
            }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.version == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.version }}
          </td>
        </tr>
        <tr>
          <td class="head">Package Size</td>
          <td class="head">Transfer Batch No.</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.size == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ $filters.formatSizeUnits(typesenseStore.currentContent?.size) }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.transfer_batch == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.transfer_batch }}
          </td>
        </tr>
        <tr>
          <td class="head">Transferring Agency</td>
          <td class="head">Creating Agency</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.transfer_agency == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.transfer_agency }}
          </td>
          <td
            v-if="
              typesenseStore?.currentContent?.agency_metadata?.CreatingAgency ==
              null
            "
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent.agency_metadata?.CreatingAgency }}
          </td>
        </tr>
        <tr>
          <td class="head">Transfer Date</td>
          <td class="head">No. of Computer Files</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.transfer_date == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{
              $filters.formatUnixDate(
                typesenseStore.currentContent?.transfer_date
              )
            }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.files_count == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.files_count }}
          </td>
        </tr>
        <tr>
          <td class="head">Item Title</td>
          <td class="head">Item ID</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.item_title == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.item_title }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.item_id == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.item_id }}
          </td>
        </tr>
        <tr>
          <td class="head">Sensitivity Classification</td>
          <td class="head">Security Grading</td>
        </tr>
        <tr>
          <td
            v-if="
              typesenseStore.currentContent?.sensitivity_classification == null
            "
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.sensitivity_classification }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.security_grading == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.security_grading }}
          </td>
        </tr>
        <!-- <tr>
          <td class="head">Total No. of DIPs in Batch</td>
          <td class="head">Total No. of AIPs in Batch</td>
        </tr>
        <tr>
          <td class="content">-</td>
          <td class="content">-</td>
        </tr> -->
        <tr>
          <td class="head">Related AIP/DIP UUID</td>
          <td class="head">SIP UUID</td>
          <!-- <td class="head">Batch Note</td> -->
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.related_package == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.related_package }}
          </td>
          <td
            v-if="typesenseStore.currentContent?.sip_uuid == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ typesenseStore.currentContent?.sip_uuid }}
          </td>
          <!-- <td 
            v-if="typesenseStore.currentContent?.transfer_note == null" 
            class="content"
          >
            -
          </td> -->
          <!-- <td v-else class="content">
            {{ typesenseStore.currentContent?.transfer_note }}
          </td> -->
        </tr>
        <tr>
          <td class="head">Fixity Check</td>
          <td class="head">Fixity Checked At</td>
        </tr>
        <tr>
          <td
            v-if="typesenseStore.currentContent?.fixity_check_passed == null"
            class="content"
          >
            -
          </td>
          <td
            v-else-if="
              typesenseStore.currentContent?.fixity_check_passed == true
            "
            class="content"
          >
            Passed
          </td>
          <td
            v-else-if="
              typesenseStore.currentContent?.fixity_check_passed == false
            "
            class="content"
          >
            Failed
          </td>
          <td
            v-if="typesenseStore.currentContent?.fixity_checked_at == null"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{
              $filters.formatUnixDateTime(
                typesenseStore.currentContent?.fixity_checked_at
              )
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useTypesenseStore } from "@/stores/typesense";

const typesenseStore = useTypesenseStore();
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  padding-bottom: 0;
  min-width: 100%;
  overflow: auto;
}
.table {
  margin: 10px;
}
</style>
